export function convertUserPropertyValuesToLabelsFormat(values) {

  for (let valueObject of values) {

    valueObject.name = valueObject.value;

  }

  return values;

}